export var RoWriterAlt = function RoWriterAlt(items, maxWidth) {
  var inputArray = items;
  var outputArray = [];

  var rowRender = function rowRender(myBaseWidth, arrayLength) {
    var width = arrayLength >= myBaseWidth ? myBaseWidth : arrayLength % myBaseWidth;
    var rowArray = [];

    for (var i = 0; i < width; i++) {
      rowArray.push(inputArray.shift());
    }

    return rowArray;
  };

  while (inputArray.length > 0) {
    var l = inputArray.length;
    var rows = Math.ceil(l / maxWidth);
    var baseWidth = Math.ceil(l / rows);
    outputArray.push(rowRender(baseWidth, l));
  }

  return outputArray;
};
export var RoWriter = function RoWriter(items, maxWidth) {
  var number = items.length;
  var rows = Math.ceil(number / maxWidth);
  var width = Math.ceil(number / rows);

  var rowMaker = function rowMaker(row, rowWidth, source, sourceLength) {
    var insertPoint = row * rowWidth;
    var rowLength = sourceLength - insertPoint >= rowWidth ? rowWidth : sourceLength % rowWidth;
    var rowArray = [];

    for (var i = 0; i < rowLength; i++) {
      rowArray.push(source[insertPoint + i]);
    }

    return rowArray;
  };

  var outputArray = [];

  for (var i = 0; i < rows; i++) {
    outputArray.push(rowMaker(i, width, items, number));
  }

  return outputArray;
};
export default RoWriter;